<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">{{ regData.status == 'M' ? '옵션상품 수정' : '옵션상품 신규 등록' }}</h2>
        </section>
        <section class="view">
          <div class="table_list">
            <table class="write">
              <colgroup>
                <col width="200">
                <col width="*">
              </colgroup>
              <tbody>
                <tr>
                  <th><span class="emp">옵션상품명</span></th>
                  <td>
                    <input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.option_goods_nm">
                  </td>
                </tr>
                <tr>
                  <th><span class="emp">옵션상품 이미지</span></th>
                  <td>
                    <div class="form_inline">
                        <button class="btn btn_md btn_blue" @click="fn_goodsFileUpload">파일업로드</button>
                        <input type="file" ref="goodsFile" @change="fn_fileGoodsChange" hidden>
                        <ul class="file_list" v-if="regData.goods_file_nm != ''">
                            <li>{{regData.goods_file_nm}}</li>
                        </ul>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th><span>옵션상품 설명</span></th>
                  <td>
                    <textarea class="form_control" style="line-height: 20px;" v-model="regData.option_goods_descript"></textarea>
                  </td>
                </tr>
                <tr>
                  <th><span class="emp">가격</span></th>
                  <td>
                    <input type="text" class="form_control" placeholder="입력해주세요." :value="regData.option_goods_price" @input="onNumberInput($event,'regData.option_goods_price')">
                  </td>
                </tr>
                <tr>
                  <th><span class="emp">사용유무</span></th>
                  <td>
                    <div class="form_inline">
                      <div class="form_radio">
                        <input type="radio" id="radio1" name="use_yn" value="Y" v-model="regData.use_yn">
                        <label for="radio1">Y</label>
                      </div>
                      <div class="form_radio">
                        <input type="radio" id="radio2" name="use_yn" value="N" v-model="regData.use_yn">
                        <label for="radio2">N</label>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="bottom_box">
              <button class="btn btn_md btn_outline" @click="fn_move_page">목록</button>
              <div class="btn_box">
                <button class="btn btn_md btn_darkblue" @click="fn_reg_option_goods">저장</button>
              </div>
            </div>
          </div>
        </section>
      </div>
      <alert-modal
            :id="'alert'"
            :text="showAlertMsg"
            :btnRight="'확인'"
            :oneBtn="false"
            :isShow="showAlert"
            :className="'btn_brown'"
            v-on:update:showSetting="fn_showSet"
        />
    </div>
</template>

<script>
  import axios from 'axios'
  import AlertModal from "@/modal/common/alertModal.vue"
  import commonUtil from "@/mixin/commonUtil";
  import alertutill from "@/mixin/alertModalUtill";

  export default {
    name: 'OptionGoodsReg',
    mixins: [alertutill,commonUtil],
    components: {
      'alert-modal' : AlertModal,
    },
    data() {
      return {
        regData : {
          option_goods_seq : '',
          option_goods_nm : '',
          option_goods_descript : '', //옵션상품 설명
          option_goods_price : '',
          use_yn : 'Y',
          goods_file_nm : '',
          status : ''
        },
        upLoadFile : {
            goods_file : ''
        },
      }
    },
    created(){
        this.regData.status = this.$store.getters['promise/getStatus'];

        if(this.regData.status == 'M'){
          this.regData.option_goods_seq = this.$store.getters['promise/getOptionGoodsSeq'];
          this.fn_search();
        }
    },
    methods : {
      fn_goodsFileUpload(){
          let fileInputElement = this.$refs.goodsFile;
          fileInputElement.click();
      },
      fn_fileGoodsChange(e){
          this.upLoadFile.goods_file = e.target.files[0];
          this.regData.goods_file_nm = this.upLoadFile.goods_file.name;
      },
      fn_reg_option_goods(){

        if(this.fn_validation_chk()){

            var frm = new FormData();

            frm.append("file",this.upLoadFile.goods_file);
            frm.append("key",JSON.stringify(this.regData));

            axios
                .post("/api/admin/promise/regOptionGoods", frm, {
                        "Content-Type": "multipart/form-data",
                        "Accept-Language" : "ko"})
                .then((res) => {
                    if(res.data.result == "ok"){
                        alert("저장되었습니다.");
                        this.fn_move_page();
                    }else{
                        let msg = res.data.errorMsg;
                        this.fn_open_alert(msg);
                    }
                })
                .catch((err) => console.log(err));
        }

      },
      fn_validation_chk(){
        if(this.regData.option_goods_nm == ''){
            alert("옵션상품명을 입력해주세요");
            return false;
        }

        if(this.regData.goods_file_nm == ''){
            alert("옵션상품 이미지를 선택해주세요");
            return false;
        }

        if(this.regData.option_goods_price === ''){
            alert("가격을 입력해주세요");
            return false;
        }

        return true;
      },
      fn_move_page(){
            this.$router.push("/admin/promise/optionGoodsMngt");
      },
      fn_search(){

        let param = new Object();
        param.option_goods_seq = this.regData.option_goods_seq;

        axios
            .post("/api/admin/promise/getOptionGoodsDetail", param)
            .then((res) => {
                this.regData.option_goods_seq =res.data.option_goods_seq;
                this.regData.option_goods_nm = res.data.option_goods_nm;
                this.regData.option_goods_descript = res.data.option_goods_descript;
                this.regData.option_goods_price = res.data.option_goods_price;
                this.regData.use_yn = res.data.use_yn;
                this.regData.goods_file_id = res.data.goods_file_id;
                this.regData.goods_file_nm = res.data.goods_file_nm;
            })
            .catch((err) => console.log(err));

      },
    }
  }
</script>
